var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_00000078725263723661038820000008409715165071990414_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250.6 20.3",
    style: {
      enableBackground: "new 0 0 250.6 20.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#597B9C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.9,11c0,1.4,7.7,3,17,2.6c52.2-2.6,78.4-2.6,78.7-2.6c-0.3,0-21.1,0-78.7-2.6 C162.5,8,154.9,9.6,154.9,11L154.9,11z M155.9,11c0-0.1,0.7-0.7,3.4-1.2c2.6-0.5,6-0.8,9.5-0.8c1,0,2,0,3,0.1 c20.7,0.9,36.7,1.5,48.7,1.9c-0.5,0-0.9,0-1.4,0H155.9L155.9,11L155.9,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.7,13.4c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4S153,9.7,153,11S152,13.4,150.7,13.4z M150.7,9.6 c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4S151.4,9.6,150.7,9.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.1,
    y: 10.5,
    className: "st0",
    width: 2.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.5,
    y: 10.5,
    className: "st0",
    width: 4.6,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.7,8.4C21.1,11,0.3,11,0,11c0.3,0,26.5,0,78.7,2.6c9.4,0.5,17-1.1,17-2.6S88.1,8,78.7,8.4z M94.7,11 H31.5c-0.5,0-1,0-1.4,0c12-0.4,28-1,48.7-1.9c1,0,2-0.1,3-0.1c3.5,0,6.9,0.3,9.5,0.8C94.1,10.3,94.7,10.9,94.7,11L94.7,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.6,11c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4s-1.1,2.4-2.4,2.4S97.6,12.3,97.6,11z M98.5,11 c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4S98.5,10.2,98.5,11z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 10.5,
    className: "st0",
    width: 2.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.5,
    y: 10.5,
    className: "st0",
    width: 4.6,
    height: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.9,8.4c-0.6-4.7-6-5.8-9.8-4.7c-5.6,1.7-10,6.8-14.9,9.8c-3,1.9-7.1,3.3-10.4,1.2 c-1.5-1-2.7-2.8-2.6-4.7c0.2-2.5,2.7-4.2,5-3c0.8,0.4,1.2-0.8,0.4-1.1c-3.4-1-6.5,2.4-5.5,5.7c1.4,4.4,6.6,5,10.3,3.6 c5.6-2.1,9.7-7.1,15-9.9c3.2-1.7,7.8-2.5,10.2,0.9c2.2,3.1-0.2,6.7-3.9,5.8c-0.4-0.1-0.8,0.4-0.4,0.8 C141.3,15.4,145.4,11.7,144.9,8.4L144.9,8.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.9,7.3c-11.4,0.4-21.8,19.5-32.8,7.5c-0.1-0.1-0.2,0-0.2,0.1c1.7,2.2,3.1,4.1,5.8,4.9 c2.8,0.8,5.7,0.4,8.3-0.7c7-2.9,11.3-9.7,18.9-11.4C139.3,7.7,139.2,7.3,138.9,7.3L138.9,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.5,1.3c-8.3-5.8-16.6,9.2-24.4,9.3c-0.1,0-0.1,0.2,0,0.2c4,0.1,6.9-2.2,10-4.5c1.9-1.4,3.8-2.7,6-3.6 c2.9-1.2,5.2-1,8.2-0.8C141.6,1.9,141.7,1.5,141.5,1.3L141.5,1.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.208e776f2d24ae10282f4b683ad1a297.svg";
export { ForwardRef as ReactComponent };